import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import TokenSafetyCheck from '../components/TokenSafetyCheck';

export default function TokenSafety() {
  const [input, setInput] = useState('');
  const [mint, setMint]   = useState('');

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-6 h-6 text-[#E8520F]" />
          <h1 className="text-2xl font-bold font-['Outfit'] text-white">Token Safety — Trust Radar</h1>
        </div>
        <p className="text-[hsl(215,16%,56%)] mt-1">
          Pre-trade rug &amp; risk intelligence. Paste any Solana mint to scan it live before you trade.
        </p>
      </div>

      <div className="flex gap-2">
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && setMint(input.trim())}
          placeholder="Solana token mint address"
          className="flex-1 bg-slate-800 border border-slate-700 text-white text-sm rounded-md px-3 h-10 font-mono focus:outline-none focus:border-[#E8520F]"
        />
        <button onClick={() => setMint(input.trim())}
          className="px-5 h-10 rounded-md bg-[#E8520F] text-white text-sm font-bold hover:bg-[#E8520F]/90 transition-colors">
          Scan
        </button>
      </div>

      <TokenSafetyCheck mint={mint} source="commander-page" />
    </div>
  );
}
